interface ICookies {
    domain: string | undefined;
    deleteCookie: (key: string) => void;
    getCookie: (key: string) => string | null;
    setCookie: (key: string, value: string, expDate?: Date) => void;
}

class Cookies implements ICookies {
    public domain = [ '.s7.ru', 'localhost' ].find(domain => window.location.hostname.match(domain));

    deleteCookie (key: string) {
        this.setCookie(key, '', new Date(0));
    }

    getCookie (key: string) {
        const re      = Cookies.getRegExp(key);
        const matches = document.cookie.match(re);
        return matches === null ? null : matches[1];
    }

    setCookie (key: string, value: string, expDate: Date) {
        document.cookie = this.prepareCookie(key, value, expDate.toUTCString());
    }

    private prepareCookie (key: string, value: any, expDate: string) {
        return `${ key }=${ value };expires=${ expDate };domain=${ this.domain }`;
    }

    private static getRegExp (key: string) {
        return new RegExp(`(?:^|; )${key.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1')}=([^;]*)`);
    }
}

export const cookies = new Cookies();
